export const blockIconsActionHelpOutline = (
	<span className='material-symbols-outlined'>help_outline</span>
);
